module.exports = __webpack_public_path__ + "img/96.6154448f.jpg";